import React, { Component } from 'react'

export default class Mic extends Component {
  render() {
    return (
        <svg
        width="48"
        height="48"
        xmlns="http://www.w3.org/2000/svg"
        id="svg22"
        version="1.1"
        viewBox="0 0 800 800"
        data-name="Ebene 1">
     
       <defs
          id="defs10">
         <clipPath
            id="d">
           <circle
              id="circle2"
              fill="none"
              r="400"
              cy="400"
              cx="400" />
         </clipPath>
         
       </defs>
       <circle
          style={{"fill":"#ffa500"}}
          id="circle12"
          fill="#1c8adb"
          r="400"
          cy="400"
          cx="400" />
       <g
          id="g20"
          clip-path="url(#d)">
         <rect
            style={{"fill":"#ffffff"}}
            id="rect16"
            ry="62.488998"
            rx="62.488998"
            height="272.19"
            width="124.98"
            y="208.03"
            x="337.51001" />
         <path
            style={{'fill':'#ffffff'}}
            id="path18"
            d="m 482.08,344.12 v 75.047 a 82.078,82.078 0 0 1 -82.078,82.078 82.078,82.078 0 0 1 -82.078,-82.078 V 344.12 h -24.922 v 76.563 a 107.01,107.01 0 0 0 94.539,106.27 v 40.096 h -50.028 v 24.922 h 124.98 v -24.922 h -50.028 v -40.096 a 107.01,107.01 0 0 0 94.539,-106.27 V 344.12 Z" />
       </g>
     </svg>
     
    )
  }
}
